import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import getIsLoyaltyEnabled from './getIsLoyaltyEnabled'

/**
 * Rollout switch for the LuxPlus+ tiered renewal reward experience: the landing-page renewal bonus
 * banner, the "More years, more rewards" tile + modal, and the redesigned manage-membership
 * retention modal.
 */
function getIsLoyaltyLuxPlusTieredRenewalRewardEnabled(state: App.State): boolean {
  return getIsLoyaltyEnabled(state) && state.optimizely.optimizelyFeatureFlags[OptimizelyFeatureFlags.loyaltyLuxPlusTieredRenewalReward]
}

export default getIsLoyaltyLuxPlusTieredRenewalRewardEnabled
